import axios from "axios";
import { server } from "../../src/server/server";

// Search Inventories
export const searchInventories = (searchTerm) => async (dispatch) => {
  try {
    dispatch({ type: "searchInventoriesRequest" });

    const { data } = await axios.get(
      `${server}/inventory/search?q=${encodeURIComponent(searchTerm)}`,
      { withCredentials: true }
    );

    dispatch({
      type: "searchInventoriesSuccess",
      payload: data.inventories,
    });
  } catch (error) {
    dispatch({
      type: "searchInventoriesFailed",
      payload: error?.response?.data?.message,
    });
  }
};



// Find Inventory by UPC
export const findInventoryByUPC = (upc) => async (dispatch) => {
  try {
    dispatch({ type: "findInventoryByUPCRequest" });

    const { data } = await axios.get(
      `${server}/inventory/by-upc/${upc}`,
      { withCredentials: true }
    );

    dispatch({
      type: "findInventoryByUPCSuccess",
      payload: data.inventory,
    });
  } catch (error) {
    dispatch({
      type: "findInventoryByUPCFailed",
      payload: error?.response?.data?.message,
    });
  }
};

// Create Inventory
export const createInventory = (newInventory) => async (dispatch) => {
  try {
    dispatch({
      type: "inventoryCreateRequest",
    });

    const { data } = await axios.post(`${server}/inventory/create-inventory`, newInventory, { withCredentials: true });
    dispatch({
      type: "inventoryCreateSuccess",
      payload: data.inventory,
    });

    dispatch(getAllInventories());

  } catch (error) {
    dispatch({
      type: "inventoryCreateFail",
      payload: error?.response?.data?.message,
    });
  }
};

// Fetch Single Inventory
export const getSingleInventory = (id) => async (dispatch) => {
  try {
    dispatch({ type: "getSingleInventoryRequest" });

    const { data } = await axios.get(`${server}/inventory/get-inventory/${id}`, { withCredentials: true });

    dispatch({
      type: "getSingleInventorySuccess",
      payload: data.inventory,
    });

  } catch (error) {
    dispatch({
      type: "getSingleInventoryFailed",
      payload: error.response?.data?.message || "An error occurred",
    });
  }
};




// Edit Inventory
export const editInventory = (id, updatedData) => async (dispatch) => {
  try {
    dispatch({ type: "editInventoryRequest" });

    const { data } = await axios.put(`${server}/inventory/update-inventory/${id}`, updatedData, { withCredentials: true });

    dispatch({
      type: "editInventorySuccess",
      payload: data.inventory,
    });

    dispatch(getAllInventories());
  } catch (error) {
    dispatch({
      type: "editInventoryFailed",
      payload: error.response.data.message,
    });
  }
};


// Update inventory variants
export const updateInventoryVariant = (id, inventoryData) => async (dispatch) => {
  try {
    dispatch({ type: "updateInventoryVariantRequest" });

    const { data } = await axios.put(`${server}/inventory/inventory-variants/${id}`, inventoryData, { withCredentials: true });

    dispatch({
      type: "updateInventoryVariantSuccess",
      payload: data.inventory,
    });
  } catch (error) {
    dispatch({
      type: "updateInventoryVariantFailed",
      payload: error?.response?.data?.message,
    });
  }
};

// Update inventory variations
export const updateInventoryVariations = (id, inventoryData) => async (dispatch) => {
  try {
    dispatch({ type: "updateInventoryVariationsRequest" });

    const { data } = await axios.put(`${server}/inventory/inventory-variations/${id}`, inventoryData, { withCredentials: true });

    dispatch({
      type: "updateInventoryVariationsSuccess",
      payload: data.inventory,
    });
  } catch (error) {
    dispatch({
      type: "updateInventoryVariationsFailed",
      payload: error?.response?.data?.message,
    });
  }
};
// Update primary variants
export const updatePrimaryVariants = (id, inventoryData) => async (dispatch) => {
  try {
    dispatch({ type: "updatePrimaryVariantsRequest" });

    const { data } = await axios.put(`${server}/inventory/primary-variants/${id}`, inventoryData, { withCredentials: true });

    dispatch({
      type: "updatePrimaryVariantsSuccess",
      payload: data.inventory,
    });
  } catch (error) {
    dispatch({
      type: "updatePrimaryVariantsFailed",
      payload: error?.response?.data?.message,
    });
  }
};

// Update secondary variants
export const updateSecondaryVariants = (id, inventoryData) => async (dispatch) => {
  try {
    dispatch({ type: "updateSecondaryVariantsRequest" });

    const { data } = await axios.put(`${server}/inventory/secondary-variants/${id}`, inventoryData, { withCredentials: true });

    dispatch({
      type: "updateSecondaryVariantsSuccess",
      payload: data.inventory,
    });
  } catch (error) {
    dispatch({
      type: "updateSecondaryVariantsFailed",
      payload: error?.response?.data?.message,
    });
  }
};

// Get Inventory By Store
export const getInventoryByStore = (storeId) => async (dispatch) => {
  try {
    dispatch({ type: "getInventoryByStoreRequest" });
    const { data } = await axios.get(`${server}/inventory/store/${storeId}`, { withCredentials: true });
    dispatch({
      type: "getInventoryByStoreSuccess",
      payload: data.inventories,
    });
  } catch (error) {
    dispatch({
      type: "getInventoryByStoreFailed",
      payload: error.response.data.message,
    });
  }
};

// Transfer Inventory
export const transferInventory = (productId, transferData) => async (dispatch) => {
  try {
    dispatch({ type: "transferInventoryRequest" });

    const { data } = await axios.post(`${server}/inventory/transfer-inventory/${productId}`,
      transferData, { withCredentials: true });

    dispatch({
      type: "transferInventorySuccess",
      payload: data.message,
    });


  } catch (error) {
    dispatch({
      type: "transferInventoryFailed",
      payload: error.response.data.message,
    });
  }
};

// Add Inventory
export const addInventory = (productId, quantity) => async (dispatch) => {
  try {
    dispatch({ type: "addInventoryRequest" });

    const { data } = await axios.put(`${server}/inventory/add-inventory/${productId}`, { quantity }, { withCredentials: true });

    dispatch({
      type: "addInventorySuccess",
      payload: data.message,
    });

  } catch (error) {
    dispatch({
      type: "addInventoryFailed",
      payload: error.response.data.message,
    });
  }
};


// Get all inventories (optimized)
export const getAllInventories = () => async (dispatch) => {
  try {
    dispatch({ type: "getAllInventoriesRequest" });

    const { data } = await axios.get(
      `${server}/inventory/get-all-inventories`, { withCredentials: true }
    );

    dispatch({
      type: "getAllInventoriesSuccess",
      payload: data.inventories,
    });
  } catch (error) {
    dispatch({
      type: "getAllInventoriesFail",
      payload: error?.response?.data?.message,
    });
  }
};

// Delete Inventory
export const deleteInventory = (id) => async (dispatch) => {
  try {
    dispatch({ type: "deleteInventoryRequest" });

    const { data } = await axios.delete(`${server}/inventory/delete-inventory/${id}`, {
      withCredentials: true,
    });

    dispatch({
      type: "deleteInventorySuccess",
      payload: data.message,
    });
    dispatch(getAllInventories());
  } catch (error) {
    dispatch({
      type: "deleteInventoryFailed",
      payload: error.response.data.message,
    });
  }
};
